'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _mapKeys = require('lodash/mapKeys');

var _mapKeys2 = _interopRequireDefault(_mapKeys);

var _groupBy = require('lodash/groupBy');

var _groupBy2 = _interopRequireDefault(_groupBy);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputValidations = require('../input-validations');

var _inputValidations2 = _interopRequireDefault(_inputValidations);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InputSelect = function InputSelect(_ref) {
  var classNames = _ref.classNames,
      error = _ref.error,
      groupOptions = _ref.groupOptions,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      required = _ref.required,
      _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      validations = _ref.validations,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ['classNames', 'error', 'groupOptions', 'id', 'label', 'name', 'options', 'onBlur', 'onChange', 'placeholder', 'required', 'styles', 'validations', 'value']);

  var propsBlacklist = ['children', 'dirty', 'initial', 'invalid', 'styles', 'touched', 'validators'];
  var allowedProps = (0, _omit2.default)(props, propsBlacklist);
  var inputId = id || name;
  var labelId = 'label-' + inputId;

  var renderOptions = function renderOptions() {
    if (groupOptions) {
      var groupedOptions = (0, _groupBy2.default)(options, 'group');
      var resultOptions = [];

      (0, _mapKeys2.default)(groupedOptions, function (opts, groupLabel) {
        if (groupLabel !== 'undefined') {
          resultOptions.push(_react2.default.createElement(
            'optgroup',
            { key: groupLabel, label: groupLabel },
            opts.map(function (_ref2, index) {
              var value = _ref2.value,
                  label = _ref2.label,
                  disabled = _ref2.disabled;
              return _react2.default.createElement(
                'option',
                { value: value, key: index, disabled: disabled },
                label
              );
            })
          ));
        } else {
          resultOptions.push(opts.map(function (_ref3, index) {
            var value = _ref3.value,
                label = _ref3.label,
                disabled = _ref3.disabled;
            return _react2.default.createElement(
              'option',
              { value: value, key: index, disabled: disabled },
              label
            );
          }));
        }
      });

      return resultOptions;
    } else {
      return options.map(function (_ref4, index) {
        var value = _ref4.value,
            label = _ref4.label,
            disabled = _ref4.disabled;
        return _react2.default.createElement(
          'option',
          { value: value, key: index, disabled: disabled },
          label
        );
      });
    }
  };

  return _react2.default.createElement(
    'div',
    { className: 'c11n-input-select ' + classNames.root },
    label && _react2.default.createElement(
      _label2.default,
      {
        id: labelId,
        inputId: inputId,
        required: required,
        styles: {
          root: styles.label,
          required: styles.required
        }
      },
      label
    ),
    _react2.default.createElement(
      'div',
      { className: classNames.wrapper },
      _react2.default.createElement(
        'select',
        _extends({
          name: name,
          id: inputId,
          value: value,
          placeholder: placeholder,
          onChange: function onChange(e) {
            return _onChange && _onChange(e.target.value);
          },
          onBlur: function onBlur(e) {
            return _onBlur && _onBlur(e.target.value);
          },
          className: classNames.input,
          required: true,
          'aria-labelledby': labelId
        }, allowedProps),
        placeholder && _react2.default.createElement(
          'option',
          { disabled: true, value: '' },
          placeholder
        ),
        renderOptions()
      ),
      _react2.default.createElement('span', { className: classNames.field, 'aria-hidden': true }),
      _react2.default.createElement(_icon2.default, { name: 'dropdown', size: 0.75, styles: styles.icon })
    ),
    error && _react2.default.createElement(_inputValidations2.default, {
      styles: { root: styles.error },
      validations: validations
    })
  );
};

InputSelect.propTypes = {
  /**
   * The label for the field
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * The name of the field
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * The ID of the field
   */
  id: _propTypes2.default.string,

  /**
   * The current value
   */
  value: _propTypes2.default.string,

  /**
   * The available options i.e. [{ value, label }, { value, label }]
   */
  options: _propTypes2.default.array.isRequired,

  /**
   * Group options by `group` param
   */
  groupOptions: _propTypes2.default.bool,

  /**
   * The change handler that will receive the updated value as it's only param
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The blur handler that will receive the updated value as it's only param
   */
  onBlur: _propTypes2.default.func,

  /**
   * The placeholder for the field
   */
  placeholder: _propTypes2.default.string,

  /**
   * Mark the field as required and displays an asterisk next to the label
   */
  required: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(_styles2.default)(InputSelect);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-select/index.js
// module id = 79
// module chunks = 0